import React from 'react'
import {Saga} from "../subscription/actions";
import connect from "react-redux/es/connect/connect";
import * as modalActions from "../ui/modal/actions";
import uuid from "uuid";
import * as userSelectors from "../user/selectors";

const SubscribeButton = ({categoryId, subscribed, loading, toggleCategorySubscription, dispatch, userLoggedIn}) => {

  if (!userLoggedIn) {
    return null;
  }

  return subscribed ?
    (<button className="btn btn-primary" disabled={loading}
             onClick={() => {

               dispatch(modalActions.openModal({
                 id: uuid.v4(),
                 type: 'confirmation',
                 title: 'Are you sure you want to Unsubscribe?',
                 text: 'You will no longer receive an email notification when an amendment is made.',
                 onConfirm: Saga.requestToggleSubscription(categoryId),
               }))
             }}>{loading ? 'Loading...' : 'Unsubscribe'}</button>)
    :
    (<button className="btn btn-primary" disabled={loading}
             onClick={() => {

               dispatch(modalActions.openModal({
                 id: uuid.v4(),
                 type: 'confirmation',
                 title: 'Are you sure you want to Subscribe?',
                 text: 'As a Subscriber you will receive an email notification each time an amendment is made.',
                 onConfirm: Saga.requestToggleSubscription(categoryId),
               }))
             }}>{loading ? 'Loading...' : 'Subscribe'}</button>);
}

const mapStateToProps = (state, ownProps) => ({
  subscribed: state.categories.subscriptions.includes(ownProps.categoryId),
  loading: state.categories.subscriptionsLoading.includes(ownProps.categoryId),
  userLoggedIn: userSelectors.isLoggedIn(state)
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeButton);